import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const accountTypesAdapter = getAdapter({ idFieldName: 'value' });

const accountTypesSlice = createSlice({
  name: 'accountTypes',
  initialState: accountTypesAdapter.getInitialState(),
  reducers: {
    setAccountTypes: (state, { payload: { accountTypes } }) => {
      accountTypesAdapter.setAll(state, accountTypes);
    },
  },
});

const selectors = accountTypesAdapter.getSelectors(({ accountTypes }) => accountTypes);

export const getAccountTypes = (state) => selectors.selectAll(state);

export const {
  setAccountTypes,
} = accountTypesSlice.actions;

export default accountTypesSlice.reducer;